import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const RightRedArrow = ({ width = '10', height = '7', className, }) => (React__default.createElement(SvgImg, { viewbox: "0 0 10 7", width: width, height: height, fill: "none", title: "arrow", extraClass: className },
    React__default.createElement("path", { d: "M1 3.50012H8.33333", stroke: "#BF0000", strokeLinecap: "round", strokeLinejoin: "round" }),
    React__default.createElement("path", { d: "M7 1L9 3.50016L7 6.16683", stroke: "#BF0000", strokeLinecap: "round", strokeLinejoin: "round" })));

export { RightRedArrow };
